<template>
  <svg version="1.1"
       id="Layer_1"
       xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
       x="0px"
       y="0px"
       viewBox="0 0 2500 2500"
       :width="width"
       :height="height"

       style="enable-background:new 0 0 2500 2500;"
       xml:space="preserve"
  >
    <a href="https://www.instagram.com/impactimagingllc/" target="_blank">
      <path class="st0" d="M833.4,1250c0-230.1,186.5-416.7,416.6-416.7s416.7,186.6,416.7,416.7s-186.6,416.7-416.7,416.7 S833.4,1480.1,833.4,1250 M608.1,1250c0,354.5,287.4,641.9,641.9,641.9s641.9-287.4,641.9-641.9S1604.5,608.1,1250,608.1  S608.1,895.5,608.1,1250 M1767.3,582.7c0,82.8,67.1,150,150,150c82.8,0,150-67.2,150-150s-67.1-149.9-150-149.9  S1767.3,499.9,1767.3,582.7 M745,2267.5c-121.9-5.6-188.1-25.8-232.1-43c-58.4-22.7-100-49.8-143.8-93.5  c-43.7-43.7-70.9-85.3-93.5-143.7c-17.2-44-37.5-110.3-43-232.1c-6.1-131.8-7.3-171.3-7.3-505.1s1.3-373.3,7.3-505.1  c5.6-121.9,25.9-188,43-232.1c22.7-58.4,49.8-100,93.5-143.8c43.7-43.7,85.3-70.9,143.8-93.5c44-17.2,110.3-37.5,232.1-43  c131.8-6.1,171.3-7.3,505-7.3c333.8,0,373.3,1.3,505.1,7.3c121.9,5.6,188,25.9,232.1,43c58.4,22.6,100,49.8,143.8,93.5  c43.7,43.7,70.8,85.4,93.5,143.8c17.2,44,37.5,110.3,43,232.1c6.1,131.9,7.3,171.3,7.3,505.1c0,333.7-1.2,373.3-7.3,505.1  c-5.6,121.9-25.9,188.1-43,232.1c-22.7,58.4-49.8,100-93.5,143.7c-43.7,43.7-85.4,70.8-143.8,93.5c-44,17.2-110.3,37.5-232.1,43  c-131.8,6.1-171.3,7.3-505.1,7.3C916.3,2274.7,876.7,2273.5,745,2267.5 M734.7,7.6c-133.1,6.1-223.9,27.2-303.4,58.1  c-82.2,31.9-151.9,74.7-221.4,144.2C140.3,279.3,97.5,348.9,65.6,431.2c-30.9,79.5-52,170.3-58.1,303.4C1.4,867.9,0,910.5,0,1250  s1.4,382.1,7.6,515.3c6.1,133.1,27.2,223.9,58.1,303.4c31.9,82.2,74.6,152,144.2,221.4c69.5,69.5,139.1,112.2,221.4,144.2  c79.6,30.9,170.3,52,303.4,58.1c133.4,6.1,175.9,7.6,515.3,7.6c339.6,0,382.1-1.4,515.3-7.6c133.1-6.1,223.9-27.2,303.4-58.1  c82.2-32,151.9-74.7,221.4-144.2c69.5-69.5,112.2-139.2,144.2-221.4c30.9-79.5,52.1-170.3,58.1-303.4c6.1-133.4,7.5-175.9,7.5-515.3  s-1.4-382.1-7.5-515.3c-6.1-133.1-27.2-223.9-58.1-303.4c-32-82.2-74.7-151.9-144.2-221.4c-69.5-69.5-139.2-112.3-221.3-144.2 c-79.6-30.9-170.4-52.1-303.4-58.1C1632.2,1.5,1589.6,0,1250.1,0C910.5,0,868,1.4,734.7,7.6"/>
    </a>
</svg>
</template>

<script>
export default {
  name: "Instagram",
  props: {
    width: String,
    height: String,
  }
}
</script>

<style lang="scss">
  .st0{
    fill:#FFFFFF;
  }

</style>